import styles from './products-add-new-product.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from '../../../mobx-stores/store-provider'
import { PageContainer } from 'components';
import { GalleryDropZoneRef, IconProducts, PageHeader } from '@touche-lts/panel-ui/dist'
import { ProductsDetailsSectionProduct } from './products-details-section'
import { ProductsImageSectionProduct } from './products-image-section'
import { ProductsSKUSSectionProduct } from './products-skus-section';
import { ProductsShippingSectionProduct } from './products-shipping-section';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ProductsOptionAddProps } from './products-add-new-product.types';
import { getMyStoreProductsPath } from 'routes';
import { useParams } from 'react-router';

const ProductsAddNewProductComponent = (props: ProductsOptionAddProps) => {
    const { storeId } = useParams<{ storeId?: string }>()
    const {
        className,
        style,
        editMode,
        productId
    } = props

  const gallery: GalleryDropZoneRef = useRef()
  const {
    routingStore: { push },
    viewProductsPageStore: { addNewProduct, InitStores },
        productsShippingsStore: { getBrandShippings },
    productsImagesStore: { setProductImagesStoreProps },
    userStore: { effectiveStoreId, setManagementStoreId },
    productsDetailsStore: { getAllDepartments, productDetails },
    generalStore: {
      showError,
    },
  } = useRootStore();

  useEffect(() => {
    setManagementStoreId(storeId)
  }, [storeId, setManagementStoreId])

  useEffect(() => {
    if (!editMode) {
      InitStores();
      getAllDepartments();
      if (effectiveStoreId) {
        getBrandShippings(effectiveStoreId);
      }
    }
  }, [editMode, InitStores, getAllDepartments, getBrandShippings, effectiveStoreId]);

  const validateProductDetails = useCallback(
    (productDetails: Record<string, any>) => {
      const requiredFields = ["name", "department", "category", "manufacturer"];

      // Check required fields
      const hasAllRequiredFields = requiredFields.every(
        (field) => productDetails?.[field]
      );
      if (!hasAllRequiredFields) return false;

      // Validate tags (optional, but max 3 if provided)
      if (productDetails?.tags) {
        const tags = productDetails.tags.split(',');
        const filteredTags = tags.filter((tag: string) => tag.trim());
        if (filteredTags.length > 3) return false;
      }

      return true;
    },
    []
  );

  const handleAddNewProduct = async () => {
    const isValid = validateProductDetails(productDetails);
    if (!isValid) {
      showError('Please fill all the required details.');
      return;
    }

    await gallery.current.handleImages();
    setProductImagesStoreProps(gallery.current.getImages());
    if (!effectiveStoreId) {
      showError('Store is not selected.');
      return;
    }
    const product = await addNewProduct(effectiveStoreId);
    if (!product) return;
    InitStores();
  };

  return (
    <PageContainer className={cl(className, styles.scrollable)} style={style}>
      <div className="container">
        {!editMode && (
          <PageHeader
            navSegments={[
              {
                icon: IconProducts,
                label: 'Products',
                onClick: () => push(getMyStoreProductsPath(storeId)),
              },
              { label: 'Add a new product' },
            ]}
            buttons={[
              {
                preset: 'secondary',
                disabled: false,
                onClick: () => push(getMyStoreProductsPath(storeId)),
                children: 'Discard',
              },
              {
                preset: 'primary',
                disabled: false,
                onClick: () => handleAddNewProduct(),
                children: 'Save',
              },
            ]}
            colorPreset="dark"
          />
        )}

        <div className="pb-4">
          <ProductsDetailsSectionProduct editMode={editMode} productId={productId} />
        </div>
        <div className="pb-4">
          <ProductsShippingSectionProduct editMode={editMode} productId={productId} />
        </div>
        <div className="pb-4">
          <ProductsImageSectionProduct imageGalleryRef={gallery} editMode={editMode} productId={productId} />
        </div>
        <ProductsSKUSSectionProduct editMode={editMode} productId={productId} />
      </div>
    </PageContainer>
  );
};

const ProductsStoreAddNewProduct = observer(ProductsAddNewProductComponent);
export { ProductsStoreAddNewProduct };
